<template>
    <form v-if="editItem" autocomplete="off" class="">
        <h4>You have been offered an employment. </h4>
        <div class="pt-4">
            <p class="mb-1">
                Please confirm your interest by either accepting or rejecting this employment offer. Acceptance time expires at:
            </p>
            <div>
                <count-down-timer size="sm" body-class="mt-3" :deadline="editItem.acceptance_deadline" />
            </div>
            <div v-if="!acceptanceTimeElapsed" class="d-grid d-sm-flex pt-4 gap-3">
                <button @click="acceptOffer()" class="btn btn-primary w-100"  type="button" >Accept Offer</button>
                <button @click="rejectOffer()" class="btn btn-warning w-100"  type="button" >Reject Offer</button>
            </div>
        </div>
    </form>
</template>

<script>
import CountDownTimer from '@/components/widgets/CountDownTimer.vue';

export default {
    components:{
        CountDownTimer
    },
    props:{
        editItem:{
            type: Object,
            default: null
        },
    },
    computed:{
        acceptanceTimeElapsed(){
            var now = new Date().getTime();
            var deadlineTime = new Date(this.editItem.acceptance_deadline).getTime();
            var distance = deadlineTime - now;
            return distance < 1;
        }
    },
    methods:{
        acceptOffer(){
            this.confirmAction({
                icon: 'success',
                html: "By accepting, you confirm your interest and move closer to resuming your next job. Are you ready to proceed?",
            }).then((result) => {
                if (result.value) {
                this.$store.dispatch("changeLoaderValue", true)
                this.$http.post(`/employment-offers/${this.editItem.id}/accept`)
                .then(response => {
                    this.$store.dispatch("changeLoaderValue", false)
                    if(response.data.success){
                        this.$emit('updateItem', response.data.data)
                    }
                })
                }
            });
        },
        rejectOffer(){
            this.confirmAction({
                icon: 'warning',
                title: "You're about to decline this employment offer.",
                html: "By rejecting, you will no longer be considered for this offer. Are you sure you want to proceed?",
            }).then((result) => {
                if (result.value) {
                this.$store.dispatch("changeLoaderValue",true)
                this.$http.post(`/employment-offers/${this.editItem.id}/reject`)
                .then(response => {
                    this.$store.dispatch("changeLoaderValue", false)
                    if(response.data.success){
                        this.$emit('updateItem', response.data.data)
                    }
                })
                }
            });
        },
    },
}
</script>